import React, { useState } from 'react';
import { View, Text, TouchableOpacity, StyleSheet, FlatList, ActivityIndicator } from 'react-native';
import Ionicons from 'react-native-vector-icons/Ionicons';


const options = [
    { id: '1', label: 'Logout', icon: 'log-out-outline', action: 'logout' },
    { id: '2', label: 'Update Password', icon: 'key-outline', action: 'updatePassword' },
    { id: '3', label: 'Delete Account', icon: 'trash-outline', action: 'deleteAccount' },
    { id: '4', label: 'Help', icon: 'help-circle-outline', action: 'help' },
];

type Props = {
    handleItemClick: (option: string) => void,
    name: string,
    isLoading: boolean,
}

export default function Header(props: Props) {
    const [open, setOpen] = useState(false);
    const toggleOpen = () => setOpen((prev) => !prev);

    const handleOptionPress = (action: string) => {
        props.handleItemClick(action);
        setOpen(false);
    };

    const renderItem = ({ item }: { item: typeof options[0] }) => (
        <TouchableOpacity
            style={styles.optionItem}
            onPress={() => handleOptionPress(item.action)}
        >
            <Ionicons name={item.icon} size={20} color="#333" style={{ marginRight: 10 }} />
            <Text style={styles.optionText}>{item.label}</Text>
        </TouchableOpacity>
    );

    return (
        <View style={styles.container}>
            <TouchableOpacity style={styles.headerRow} onPress={toggleOpen}>
                <Text style={styles.nameText}>{props.name}</Text>
                {props.isLoading && <ActivityIndicator size="large" color="#007AFF" />}
                <Ionicons
                    name={open ? 'chevron-up-outline' : 'chevron-down-outline'}
                    size={20}
                    color="#333"
                />
            </TouchableOpacity>

            {open && (
                <FlatList
                    data={options}
                    keyExtractor={(item) => item.id}
                    renderItem={renderItem}
                    style={styles.dropdown}
                />
            )}
        </View>
    );
}

const styles = StyleSheet.create({
    container: {
        padding: 10,
        backgroundColor: '#fff',
        elevation: 3,
        shadowColor: '#000',
        shadowOpacity: 0.1,
        shadowOffset: { width: 0, height: 2 },
        shadowRadius: 3,
    },
    headerRow: {
        flexDirection: 'row',
        justifyContent: 'space-between',
        alignItems: 'center',
    },
    nameText: {
        fontSize: 18,
        fontWeight: '600',
    },
    dropdown: {
        marginTop: 10,
    },
    optionItem: {
        flexDirection: 'row',
        alignItems: 'center',
        paddingVertical: 10,
    },
    optionText: {
        fontSize: 16,
    },
});